<div class="p-grid">
    <div class="p-col-12" *ngIf="notes">
        <div class="card">
            <div id="dataListWrapper">
                <p-dataView #dv [value]="notes" [paginator]="true" filterBy="Note,PostingUserFullName,DateAdded"
                            [rows]="15"
                            [showCurrentPageReport]="true"
                            [rowsPerPageOptions]="rowsPerPageOptions"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                    <ng-template pTemplate="header">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-2 p-md-2">
                                <p-button styleClass="fullwidthbtn" label="Back" routerLink="/deal/{{dealId}}"></p-button>
                            </div>
                            <div class="p-col-12 p-lg-2 p-md-2">
                                <p-button styleClass="fullwidthbtn" label="Add Note" (click)="showAddNoteDialog()"></p-button>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4"></div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                 <input type="search" pInputText placeholder="Search Note" (input)="dv.filter($event.target.value)">                               
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-note pTemplate="listItem">                       
                        <div class="p-col-12">
                            <div class="object-list-item" style="padding:1em;">
                                <div class="object-list-detail">
                                    <div class="p-grid" style="margin-bottom:-1.75em; margin-top:-0.75em;">
                                        <div class="p-col-12 p-lg-8 p-md-8">
                                            <div class="object-description"><b>{{note.PostingUserFullName}}</b> added a note on <strong>{{note.DateAdded | convertToDatetime}}</strong></div>
                                        </div>
                                        <div class="p-col-12 p-lg-4 p-md-4" *ngIf="canEditDeleteDealNote">
                                            <div class="floatRight">
                                                <span style="margin-right:5px;">
                                                    <p-button icon="pi pi-pencil" pTooltip="Edit Note" (click)="showEditNoteDialog(note)"></p-button>
                                                </span>                                          
                                                <p-button icon="pi pi-trash" pTooltip="Delete Note" (click)="deleteNote(note)"></p-button>
                                            </div>                                            
                                        </div>
                                    </div>                                   
                                    <div class="object-description">
                                        {{removeHTML(note.Note)}}
                                    </div>
                                </div>                      
                            </div>
                        </div>
                    </ng-template>
                </p-dataView>
            </div>
        </div>
    </div>
</div>

<p-dialog [breakpoints]="{'960px': '100vw'}" styleClass="dialog-medium" draggable="false" modal="true" [closable]="false"
        header="Add Deal Note" [(visible)]="addNoteDialogVisible">
    <p-divider></p-divider>
    <div class="p-grid">
        <div class="p-col-12 error-notify-text" *ngIf="addNoteDialogMessage.length>0">
            {{addNoteDialogMessage}}
        </div>
        <div class="p-col-12">
            <textarea pInputTextarea [rows]="15" [cols]="40" [(ngModel)]="noteToBeAdded"></textarea>
        </div>      
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Add" (click)="addNote()"></button>
        <button pButton type="button" label="Cancel" (click)="hideAddNoteDialog()"></button>
    </ng-template>
</p-dialog>

<p-dialog [breakpoints]="{'960px': '100vw'}" styleClass="dialog-medium" draggable="false" modal="true" [closable]="false"
          header="Edit Deal Note" [(visible)]="editNoteDialogVisible">
    <p-divider></p-divider>
    <div class="p-grid">
        <div class="p-col-12 error-notify-text" *ngIf="editNoteDialogMessage.length>0">
            {{editNoteDialogMessage}}
        </div>
        <div class="p-col-12">
            <textarea pInputTextarea [rows]="15" [cols]="40" [(ngModel)]="selectedNote.Note"></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Save" (click)="updateNote()"></button>
        <button pButton type="button" label="Cancel" (click)="hideEditNoteDialog()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog header="Confirmation" icon="ui-icon-warning" width="800"></p-confirmDialog>
